<div class="flex-row-new">
  @if ((doesAnyVideoUrlExist$ | async) === true) {
    <div class="flex-items-new">
      @for (videoUrl of isDownloadingMultiVideoStorageLocatorUrls; track $index; let i = $index) {
        <app-button
          [type]="(isDownloadingMultiVideoStorageLocatorUrls[i]) ? 'tertiary' : 'secondary'"
          [isDisabled]="isDownloadingMultiVideoStorageLocatorUrls[i]"
          [dataTestId]="'download-video-button-' + i"
          (buttonClick)="onMultiVideoStorageLocatorButtonClick(i)"
          alt="Button to download video">
          @if (isDownloadingMultiVideoStorageLocatorUrls[i] === true) {
            <div>
              <img class="button-icon rotate"
                data-testid="downloading-video-button-icon"
                src="assets/icons/loading-icon.svg"
                alt="Loading icon" />
                @if (isDownloadingMultiVideoStorageLocatorUrls.length === 1) {
                  <span> Downloading</span>
                }
                @if (isDownloadingMultiVideoStorageLocatorUrls.length > 1) {
                  <span> Downloading - Part {{ i + 1 }}</span>
                }
              </div>
            }
            @if (isDownloadingMultiVideoStorageLocatorUrls[i] === false) {
              <div>
                @if (isDownloadingMultiVideoStorageLocatorUrls.length === 1) {
                  <span> Download Session Video</span>
                }
                @if (isDownloadingMultiVideoStorageLocatorUrls.length > 1) {
                  <span> Download - Part {{ i + 1 }}</span>
                }
              </div>
            }
          </app-button>
        }
      </div>
    }
  </div>
